<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { frontendURL } from 'dashboard/helper/URLHelper';

const props = defineProps({
  conversation: {
    type: Object,
    required: true,
  },
});

const router = useRouter();

const currentFunnel = computed(() => {
  // Pegar o primeiro funil da conversa
  const funnels = props.conversation.conversation_kanban_columns || [];
  console.log('CardFunnel - conversation ID:', props.conversation.id);
  console.log('CardFunnel - conversation object:', props.conversation);
  console.log('CardFunnel - conversation_kanban_columns:', funnels);
  console.log('CardFunnel - currentFunnel result:', funnels.length > 0 ? funnels[0] : null);
  return funnels.length > 0 ? funnels[0] : null;
});

const onFunnelClick = (e) => {
  e.stopPropagation();
  
  if (!currentFunnel.value) return;
  
  const path = frontendURL(
    `/app/accounts/${props.conversation.account_id}/kanban/${currentFunnel.value.kanban_pipeline.id}`
  );
  
  router.push({ path });
};
</script>

<template>
  <div
    v-if="currentFunnel"
    class="flex items-center gap-1.5 min-w-0 cursor-pointer hover:opacity-80 transition-opacity"
    @click="onFunnelClick"
  >
    <div
      :style="{ backgroundColor: currentFunnel.kanban_column.color }"
      class="size-1.5 rounded-full flex-shrink-0"
    />
    <span class="text-sm text-n-slate-10 truncate">
      {{ currentFunnel.kanban_column.name }}
    </span>
  </div>
</template>
